<template>
  <b-row
    v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
    class="content-header"
  >

    <!-- Content Left -->
    <b-col
      class="content-header-left mb-2"
      cols="12"
      md="9"
    >
      <b-row class="breadcrumbs-top">
        <b-col cols="12">
          <h2 class="content-header-title float-left pr-1 mb-0">
            {{ $route.meta.pageTitle }}
          </h2>
          <div class="breadcrumb-wrapper">
            <b-breadcrumb>
              <b-breadcrumb-item to="/">
                <feather-icon
                  icon="HomeIcon"
                  size="16"
                  class="align-text-top"
                />
              </b-breadcrumb-item>
              <b-breadcrumb-item
                v-for="item in $route.meta.breadcrumb"
                :key="item.text"
                :active="item.active"
                :to="item.to"
              >
                {{ item.text }}
              </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-col>
      </b-row>
    </b-col>

    <!-- Content Right -->
    <b-col
      class="content-header-right text-md-right d-md-block d-none mb-1"
      md="3"
      cols="12"
      v-if="$route.name == 'grupo' || $route.name == 'grupo-edit' || $route.name == 'usina' || $route.name == 'usina-edit' || $route.name == 'usina-edit-info'"
    >
    
      <b-dropdown
        variant="link"
        no-caret
        toggle-class="p-0"
        right
      >

        <template #button-content>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="btn-icon"
          >
            <feather-icon icon="PaperclipIcon" />
          </b-button>
        </template>

        <b-dropdown-item 
        v-if="$route.name == 'grupo'"
        v-on:click="downGrupoAll()">
          <feather-icon
            icon="ArrowDownIcon"
            size="16"
          />
          <span class="align-middle ml-50">CSV</span>
        </b-dropdown-item>

        <b-dropdown-item 
        v-if="$route.name == 'grupo-edit'"
        v-on:click="downGrupo()">
          <feather-icon
            icon="ArrowDownIcon"
            size="16"
          />
          <span class="align-middle ml-50">CSV</span>
        </b-dropdown-item>

        <b-dropdown-item 
        v-if="$route.name == 'grupo-edit'"
        v-on:click="upGrupo()">
          <feather-icon
            icon="ArrowUpIcon"
            size="16"
          />
          <span class="align-middle ml-50">Atualizar</span>
        </b-dropdown-item>

        <b-dropdown-item 
        v-if="$route.name == 'usina'"
        v-on:click="downUsinaAll()">
          <feather-icon
            icon="ArrowDownIcon"
            size="16"
          />
          <span class="align-middle ml-50">CSV</span>
        </b-dropdown-item>

        <b-dropdown-item 
        v-if="$route.name == 'usina'"
        v-on:click="downUsinaAllInfo()">
          <feather-icon
            icon="ArrowDownIcon"
            size="16"
          />
          <span class="align-middle ml-50">CSV (Info)</span>
        </b-dropdown-item>

        <b-dropdown-item 
        v-if="$route.name == 'usina-edit'"
        v-on:click="downUsina()">
          <feather-icon
            icon="ArrowDownIcon"
            size="16"
          />
          <span class="align-middle ml-50">CSV</span>
        </b-dropdown-item>

        <b-dropdown-item 
        v-if="$route.name == 'usina-edit'"
        v-on:click="upUsina()">
          <feather-icon
            icon="ArrowUpIcon"
            size="16"
          />
          <span class="align-middle ml-50">Atualizar</span>
        </b-dropdown-item>

        <b-dropdown-item 
        v-if="$route.name == 'usina-edit-info'"
        v-on:click="downUsinaInfo()">
          <feather-icon
            icon="ArrowDownIcon"
            size="16"
          />
          <span class="align-middle ml-50">CSV</span>
        </b-dropdown-item>

        <b-dropdown-item 
        v-if="$route.name == 'usina-edit-info'"
        v-on:click="upUsinaInfo()">
          <feather-icon
            icon="ArrowUpIcon"
            size="16"
          />
          <span class="align-middle ml-50">Atualizar</span>
        </b-dropdown-item>

      </b-dropdown>
    </b-col>

  </b-row>
</template>

<script>
import {
  BBreadcrumb, BBreadcrumbItem, BRow, BCol, BDropdown, BDropdownItem, BButton,
} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
import useJwt from '@/auth/jwt/useJwt';
import { saveAs } from 'file-saver';
import { mapMutations } from 'vuex';

export default {
  directives: {
    Ripple,
  },
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BButton,
  },
  methods: {
    ...mapMutations(['updateLoading']),

    downGrupoAll() {
        this.updateLoading(true);
        useJwt.get(`/api/grupo/csv/download`).then(response => {
          if(response.data){
            this.updateLoading(false);

            let blob = new Blob([response.data], {type: "text/csv;charset=utf-8"});
            saveAs(blob, 'grupo.csv');

            return;
          }
          else{
            this.updateLoading(false);

            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'error',
                text: 'Ocorreu um erro ao gerar o CSV',
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            });

            return;
          }
        });
    },
    downGrupo() {
        this.updateLoading(true);
        useJwt.get(`/api/grupo/csv/download/${this.$route.params.alias}`).then(response => {
          if(response.data){
            this.updateLoading(false);

            let blob = new Blob([response.data], {type: "text/csv;charset=utf-8"});
            saveAs(blob, `${this.$route.params.alias}.csv`);

            return;
          }
          else{
            this.updateLoading(false);

            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'error',
                text: 'Ocorreu um erro ao gerar o CSV',
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            });

            return;
          }
        })
    },
    upGrupo() {
      this.$router.replace(`/grupo/atualizar/${this.$route.params.alias}`);
    },
    downUsina() {
      this.updateLoading(true);
      useJwt.get(`/api/usina/csv/download/${this.$route.params.alias}`).then(response => {
        if(response.data){
          this.updateLoading(false);
          let blob = new Blob([response.data], {type: "text/csv;charset=utf-8"});
          saveAs(blob, `${this.$route.params.alias}.csv`);

          return;
        }
        else{
          this.updateLoading(false);

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error',
              text: 'Ocorreu um erro ao gerar o CSV',
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          });

          return;
        }
      })
    },

    upUsina() {
      this.$router.replace(`/usina/atualizar/${this.$route.params.alias}`);
    },

    downUsinaAll() {
      this.updateLoading(true);
      useJwt.get(`/api/usina/csv/download`).then(response => {
        if(response.data){
          this.updateLoading(false);
          let blob = new Blob([response.data], {type: "text/csv;charset=utf-8"});
          saveAs(blob, `usina.csv`);

          return;
        }
        else{
          this.updateLoading(false);

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error',
              text: 'Ocorreu um erro ao gerar o CSV',
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          });

          return;
        }
      })
    },

    downUsinaAllInfo() {
      this.updateLoading(true);
      useJwt.get(`/api/usina/csv/info/download`).then(response => {
        if(response.data){
          this.updateLoading(false);
          let blob = new Blob([response.data], {type: "text/csv;charset=utf-8"});
          saveAs(blob, `usina_info.csv`);

          return;
        }
        else{
          this.updateLoading(false);

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error',
              text: 'Ocorreu um erro ao gerar o CSV',
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          });

          return;
        }
      })
    },

    downUsinaInfo() {
      this.updateLoading(true);
      useJwt.get(`/api/usina/csv/info/download/${this.$route.params.id}`).then(response => {
        if(response.data){
          this.updateLoading(false);

          let blob = new Blob([response.data], {type: "text/csv;charset=utf-8"});
          saveAs(blob, `${this.$route.params.id}_info.csv`);

          return;
        }
        else{
          this.updateLoading(false);

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error',
              text: 'Ocorreu um erro ao gerar o CSV',
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          });

          return;
        }
      })
    },

    upUsinaInfo() {
      this.$router.replace(`/usina/atualizar/info/${this.$route.params.id}`);
    },

  }
}
</script>
